import { DownloadIcon, ListChecksIcon, PrinterIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface Step {
  icon: LucideIcon
  title: string
  description: string
}

export const steps: Step[] = [
  {
    icon: DownloadIcon,
    title: 'Scarichi subito',
    description: 'Dopo il pagamento ricevi accesso immediato ai volumi e ai materiali pronti.',
  },
  {
    icon: ListChecksIcon,
    title: 'Scegli l’attività',
    description:
      'Vai al livello della tua classe (1ª Primaria → 3ª Media) e seleziona la proposta della giornata.',
  },
  {
    icon: PrinterIcon,
    title: 'Stampi e insegni',
    description:
      'Stampa le schede e segui la guida: attività progressive, senza caos e senza preparazioni infinite.',
  },
]
